export default __webpack_public_path__ + "static/media/triangle-down.192e96a0.svg";